import ConfigInitialized from './ConfigInitialized.jsx';

export default ConfigInitialized;


// WEBPACK FOOTER //
// ./src/components/ConfigInitialized/index.jsx